/* eslint-disable */
import React from 'react'
import $ from 'jquery'
import {loadBrand} from '../BaseComponent/configTheme'
import axios from 'axios'
import {Base64} from 'js-base64'
import {DecryptionText} from '../Base/decryptionText'
import moment from 'moment-jalali'
import AutoComplete from '../BaseComponent/autocomplete'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import http from '../Interceptor/Interseptor'
import AutoCompleteMulti from '../BaseComponent/AutoCompleteMulti'
import {Map, TileLayer, Polyline, Polygon} from 'react-leaflet'

import {renderToStaticMarkup} from 'react-dom/server'
import {divIcon} from 'leaflet'

class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      obj: {},
      providerId: '2',
      providerIds: [],
      latLngMarker: ['', ''],
      activePolygon: false,
      points: [],
      polygone: []
    }
  }

  toByteArr = (string) => {
    var bytes = []

    for (var i = 0; i < string.length; ++i) {
      bytes.push(string.charCodeAt(i))
    }
    return bytes
  }

  componentDidMount() {
    $(function() {
      $('.header').show()
    })
    // var input = '09351243935'
    // var key = this.toByteArr('Fs@#dsGERHcx482$')
    // var iv = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
    // var binaryEncryptionKey = key;
    // console.log(binaryEncryptionKey)
    // var cipher = crypto.createCipheriv( "AES-128-CBC", binaryEncryptionKey, iv )
    //
    // var encryptedInput = (
    //     cipher.update( input, "utf8", "base64" ) +
    //     cipher.final( "base64" )
    // );
    //
    // var decipher = crypto.createDecipheriv( "AES-128-CBC", binaryEncryptionKey, iv );
    //
    // var xxx = '8ZBO+1rRw37ta/ks/D3raw=='
    //
    // var decryptedInput = (
    //     decipher.update( xxx, "base64", "utf8" ) +
    //     decipher.final( "utf8" )
    // );
    //
    // console.log( "Input:", input );
    // console.log( "Encrypted Input:", encryptedInput );
    // console.log( "Decrypted Input:", decryptedInput );
    // console.log(DecryptionText('hq+JUpXWnv35yCumRG9a0w'))
  }

  togglePolygon = () => {
    this.setState({
      activePolygon: !this.state.activePolygon
    })
  }

  hoverMap = (e) => {
    if (this.state.activePolygon) {
      console.log(e.latlng)
    }
  }

  setPoint = (e) => {
    if (this.state.activePolygon && !this.state.polygone.length) {
      const points = this.state.points
      points.push(e.latlng)
      this.setState(
        {
          points
        },
        () => {
          this.getMarkers()
        }
      )
    }
  }

  getMarkers() {
    let points = this.state.points
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lng) {
        array.push([item.lat, item.lng])
      }
    })
    return array
  }

  hasPolygone() {}

  makePolygon = () => {
    this.setState({
      polygone: [...this.getMarkers(), this.getMarkers()[0]],
      points: []
    })
  }

  render() {
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <div className="bigLogo" style={{background: loadBrand().color}}>
            <img src={loadBrand().logo} alt="logo" />
          </div>
          {/* <div className="addressMap position-relative mt-5">
            <section className="position-absolute" style={{ zIndex: 999 }}>
              <button
                title={this.state.activePolygon ? "غیر فعال کردن" : "فعال کردن"}
                className={
                  this.state.activePolygon ? "active-polygon" : "polygon"
                }
                onClick={this.togglePolygon}
              >
                <img src={require("../../image/polygon.png")} width={30} />
              </button>

              {this.state.polygone.length && this.state.activePolygon ? (
                <button
                  className="polygon mx-3 text-danger p-1"
                  onClick={() => this.setState({ polygone: [], points: [] })}
                >
                  حذف چند ضلعی
                </button>
              ) : null}

              {this.state.points.length >= 3 && this.state.activePolygon && (
                <button
                  className="polygon mx-3 p-1 text-success"
                  onClick={this.makePolygon}
                >
                  ساخت چند ضلعی
                </button>
              )}
            </section>
            <Map
              center={[35.6892, 51.389]}
              zoom={10}
              style={{ height: "500px" }}
              onclick={this.setPoint}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              <Polyline positions={this.getMarkers()} />
              {this.state.activePolygon ? (
                <Polygon positions={this.state.polygone} />
              ) : null}
            </Map>
          </div> */}
        </div>
      </div>
    )
  }
}

export default Dashboard
